import * as React from "react";
import { forwardRef } from "react";
const SvgDropDownDisabled = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 9, viewBox: "0 0 14 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13 1L7 7L1 1", stroke: "#9396AA", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgDropDownDisabled);
export { ForwardRef as ReactComponent };
